import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatPaginator, PageEvent } from '@angular/material';
import { CadastrarFornecedorEstruturaModalComponent } from '../modals/cadastrar-fornecedor-estrutura-modal/cadastrar-fornecedor-estrutura-modal.component';
import { CarregandoService } from '../services/carregando.service';
import { NotificacaoService } from '../services/notificacao.service';
import { FornecedorEstruturaService } from '../services/fornecedor-estrutura.service';
import { FornecedorEstrutura } from '../models/fornecedor-estrutura';
import { PremissasService } from '../services/premissas.service';
import { FornecedorEstruturaItem } from '../models/fornecedor-estrutura-item';
import { UtilitarioService } from '../services/utilitario.service';
import { Orientacao, TipoFiltroProduto } from "../models/enum";
import { FornecedorEstruturaItemService } from '../services/fornecedor-estrutura-item.service';
import { Filtro } from '../models/filtro';
import { ItemPedido } from '../models/pedido';
import { ProdutosModalComponent } from '../modals/produtos-modal/produtos-modal.component';
import { FormulaItemEstruturaModalComponent } from '../modals/formula-item-estrutura-modal/formula-item-estrutura-modal.component';
import swal from 'sweetalert2';
import { SimulacaoEstruturaModalComponent } from '../modals/simulacao-estrutura-modal/simulacao-estrutura-modal.component';
import { ClonarEstruturaModalComponent } from '../modals/clonar-estrutura-modal/clonar-estrutura-modal.component';
import { VariavelPersonalizadaModalComponent } from '../modals/variavel-personalizada-modal/variavel-personalizada-modal.component';
import { EstruturasPersonalizadas } from '../models/estruturas-personalizadas';
import { ProdutosV2ModalComponent } from "../modals/produtos-v2-modal/produtos-v2-modal.component";
import { PremissasSistema } from "../models/premissas-sistema";

declare const $: any;

@Component({
  selector: 'app-cadastrar-estrutura-layout',
  templateUrl: './cadastrar-estrutura-layout.component.html',
  styleUrls: ['./cadastrar-estrutura-layout.component.scss']
})
export class CadastrarEstruturaLayoutComponent implements OnInit {
  fornecedores: FornecedorEstrutura[];

  usarTelCeramico = false;
  estruturasPersonalizadas: EstruturasPersonalizadas = new EstruturasPersonalizadas();

  item: FornecedorEstruturaItem;
  orientacaoPaisagem = true;

  fornecedorSelecionado: any;
  telhadoSelecionado: any;
  orientacaoSelecionada: any;

  produtosSelecionados = [];

  campoOrdenacao = 'descricao';
  ordenarDesc = false;
  paginacao = { tamanhoMaximo: 10, total: 0, paginaAtual: 1 };
  listaDeItensPorPagina = [];
  itensPorPagina = 10;

  itensEstrutura: FornecedorEstruturaItem[] = [];

  filtroDescricao: Filtro = { Propriedade: 'descri', Valor: '' };
  filtros: Filtro[] = [this.filtroDescricao];

  premissasSistema: PremissasSistema = new PremissasSistema();

  @ViewChild('paginator', { static: false }) paginator: MatPaginator;

  constructor(
    private carregandoService: CarregandoService,
    private notificacaoService: NotificacaoService,
    private fornecedorEstruturaService: FornecedorEstruturaService,
    private dialog: MatDialog,
    private premissasService: PremissasService,
    private utilitarioService: UtilitarioService,
    private fornecedorEstruturaItemService: FornecedorEstruturaItemService
  ) {
    this.item = new FornecedorEstruturaItem();
  }

  ngOnInit(): void {
    this.buscarPremissasSistema();
    this.buscarFornecedoresEstrutura();
    this.buscarUsarTelhadoCeramico();
    this.buscarEstruturasPersonalizadas();
    this.buscarDesativarPaisagem();
  }

  buscarPremissasSistema() {
    this.carregandoService.mostra('buscarPremissasSistema');

    this.premissasService.consultarPremissasSistema().subscribe(
      async (premissas) => {
        this.premissasSistema = premissas;
        this.carregandoService.esconde('buscarPremissasSistema');
      },
      (erro) => {
        this.carregandoService.esconde('buscarPremissasSistema');
        this.notificacaoService.erro(erro);
      }
    );
  }

  ordena(campo) {

    if (campo) {

      this.campoOrdenacao = campo;
      this.ordenarDesc = !this.ordenarDesc;

      this.mudaDePagina({ length: this.paginator.length, pageIndex: this.paginator.pageIndex, pageSize: this.paginator.pageSize });
    }

    return false;
  }

  toggleStatusItem(idItem, ativo) {
    this.carregandoService.mostra('toggleStatusItem');
    this.fornecedorEstruturaItemService.alterarStatus(idItem, !ativo).subscribe(
      () => {
        this.carregandoService.esconde('toggleStatusItem');
        this.buscarItensEstrutura();
      },
      err => {
        this.carregandoService.esconde('toggleStatusItem');
        this.notificacaoService.erro(err);
      }
    );
  }

  alterarStatusTodos(ativo) {

    if (this.fornecedorSelecionado === undefined || this.telhadoSelecionado === undefined || this.orientacaoSelecionada === undefined) return;

    this.carregandoService.mostra('toggleStatusTodos');
    this.fornecedorEstruturaItemService.alterarStatusTodos(ativo, this.fornecedorSelecionado, this.telhadoSelecionado, this.orientacaoSelecionada).subscribe(
      () => {
        this.carregandoService.esconde('toggleStatusTodos');
        this.buscarItensEstrutura();
      },
      err => {
        this.carregandoService.esconde('toggleStatusTodos');
        this.notificacaoService.erro(err);
      }
    );
  }

  mudaDePagina(pageEvent: PageEvent) {
    this.itensPorPagina = pageEvent.pageSize;
    this.paginacao.paginaAtual = pageEvent.pageIndex + 1;

    this.buscarItensEstrutura();
  }

  buscarDesativarPaisagem() {
    this.carregandoService.mostra('buscarDesativarPaisagem');
    this.premissasService.consultarDesativarPaisagem().subscribe(f => {
      this.orientacaoPaisagem = f.valor;

      this.carregandoService.esconde('buscarDesativarPaisagem');
    }, (erro) => {
      this.carregandoService.esconde('buscarDesativarPaisagem');
      this.notificacaoService.erro(erro);
    });
  }

  selecionarFornecedor(fornecedor: any) {
    this.fornecedorSelecionado = fornecedor;
    this.buscarItensEstrutura();
  }

  selecionarTelhado(telhado: any) {
    this.telhadoSelecionado = telhado;
    this.buscarItensEstrutura();
  }

  selecionarOrientacao(orientacao: any) {
    this.orientacaoSelecionada = orientacao === 'retrato' ? Orientacao.Retrato : Orientacao.Paisagem;
    this.buscarItensEstrutura();
  }

  buscarEstruturasPersonalizadas() {
    this.carregandoService.mostra('buscarEstruturasPersonalizadas');
    this.premissasService.consultarEstruturasPersonalizadas().subscribe(f => {
      this.estruturasPersonalizadas = f;

      this.carregandoService.esconde('buscarEstruturasPersonalizadas');
    }, (erro) => {
      this.carregandoService.esconde('buscarEstruturasPersonalizadas');
      this.notificacaoService.erro(erro);
    });
  }

  buscarUsarTelhadoCeramico() {
    this.carregandoService.mostra('buscarVerPrecosProdutos');
    this.premissasService.consultarUsarTelCeramico().subscribe(f => {
      this.usarTelCeramico = f.valor;
      this.carregandoService.esconde('buscarVerPrecosProdutos');
    }, (erro) => {
      this.carregandoService.esconde('buscarVerPrecosProdutos');
      this.notificacaoService.erro(erro);
    });
  }

  abrirModalCadastrarFornecedor() {
    const largura = Number(($('body').width()));
    const dialogRef = this.dialog.open(CadastrarFornecedorEstruturaModalComponent, {
      width: largura > 830 ? '800px' : (($('body').width()).toString() + 'px'),
      data: {
      },
      panelClass: 'modal-card'
    });

    dialogRef.afterClosed().subscribe(
      result => {
        if (result) {
          this.buscarFornecedoresEstrutura();
        }
      },
      err => {
        this.notificacaoService.erro(err);
      }
    );
  }

  abrirModalVariaveis() {
    const largura = Number(($('body').width()));
    const dialogRef = this.dialog.open(VariavelPersonalizadaModalComponent, {
      width: largura > 500 ? '580px' : (($('body').width()).toString() + 'px'),
      data: {
      },
      panelClass: 'modal-card'
    });

    dialogRef.afterClosed().subscribe(
      result => {
        if (result) {
          this.buscarFornecedoresEstrutura();
        }
      },
      err => {
        this.notificacaoService.erro(err);
      }
    );
  }

  buscarFornecedoresEstrutura() {
    this.carregandoService.mostra('buscarFornecedoresEstrutura');

    this.fornecedorEstruturaService.consultarFornecedores().subscribe(
      forns => {
        this.fornecedores = forns;

        this.selecionarFornecedor(0);

        this.fornecedores.forEach((forn: FornecedorEstrutura) => {
          forn.logo$ = this.fornecedorEstruturaService.consultarImagemPorId(forn.id)
            .map(m => m !== null && m !== undefined ? this.utilitarioService.toBase64ComInicio(m) : Promise.resolve('')).toPromise();
          forn.logo$.then(p => { forn.buscouImagem = true; });
        });

        this.carregandoService.esconde('buscarFornecedoresEstrutura');
      },
      err => {
        this.carregandoService.esconde('buscarFornecedoresEstrutura');
        this.notificacaoService.erro(err);
      }
    );
  }

  buscarItensEstrutura() {
    if (this.fornecedorSelecionado === undefined || this.telhadoSelecionado === undefined || this.orientacaoSelecionada === undefined) return;

    this.carregandoService.mostra('buscarItensEstrutura');

    this.fornecedorEstruturaItemService.consultarComPaginacao(
      this.filtroDescricao.Valor,
      this.fornecedorSelecionado,
      undefined,
      this.telhadoSelecionado,
      this.orientacaoSelecionada,
      this.paginacao.paginaAtual,
      0,
      this.campoOrdenacao,
      this.ordenarDesc ? 'desc' : 'asc'
    ).subscribe(
      dados => {
        this.itensEstrutura = dados.itens;
        this.listaDeItensPorPagina = this.utilitarioService.calculaItensPorPagina(dados.total);

        if (this.itensPorPagina > this.listaDeItensPorPagina[this.listaDeItensPorPagina.length - 1]) {
          this.itensPorPagina = 10;
        }

        this.paginacao.total = dados.total;

        this.carregandoService.esconde('buscarItensEstrutura');
      },
      err => {
        this.carregandoService.esconde('buscarItensEstrutura');
        this.notificacaoService.erro(err);
      }
    );
  }

  excluirItem(item) {
    swal({
      title: 'Atenção!!',
      text: 'Deseja realmente excluir o item da estrutura?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonClass: 'btn btn-info',
      cancelButtonClass: 'btn btn-danger',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não',
      buttonsStyling: false
    }).then((result) => {
      if (result.value) {

        this.carregandoService.mostra('excluir');
        this.fornecedorEstruturaItemService.excluir(item.id).subscribe(resp => {

          this.notificacaoService.sucesso('Item de estrutura excluído com sucesso!!!');
          this.carregandoService.esconde('excluir');
          this.buscarItensEstrutura();

        }, (erro) => {
          this.carregandoService.esconde('excluir');
          this.notificacaoService.erro(erro);
        });

      }
    });

  }

  salvar() {
    this.carregandoService.mostra('salvar');

    this.fornecedorEstruturaItemService.salvar(this.item).subscribe(
      () => {
        this.carregandoService.mostra('salvar');
        this.notificacaoService.sucesso('Estrutura salva com sucesso!!!');
      },
      err => {
        this.carregandoService.esconde('salvar');
        this.notificacaoService.erro(err);
      }
    );
  }

  pesquisarProdutos() {
    let dialogRef;
    const config = {
      width: ($('body').width()).toString() + 'px',
      data: {
        somenteEstrutura: true,
        produtos: this.produtosSelecionados,
        selecionaSomenteUm: true,
        situacao: 'T'
      },
      panelClass: 'modal-card',
      // maxHeight: '90vh'
    };

    if (this.premissasSistema.filtroProduto === TipoFiltroProduto.Agrupamento) {
      dialogRef = this.dialog.open(ProdutosModalComponent, config);
    } else {
      dialogRef = this.dialog.open(ProdutosV2ModalComponent, config);
    }

    dialogRef.afterClosed().subscribe((result: ItemPedido[]) => {
      if (result) {
        const produtoSelecionado = result[0];
        const item = new FornecedorEstruturaItem();
        item.idProduto = produtoSelecionado.produtoTela.idProduto;
        item.produto = produtoSelecionado.produtoTela.descricao;
        item.telhado = this.telhadoSelecionado;
        item.idFornecedor = this.fornecedorSelecionado;
        item.orientacao = this.orientacaoSelecionada;

        this.editarItem(item);
      }
    });
  }

  editarItem(item) {
    const largura = Number(($('body').width()));
    const dialogRef = this.dialog.open(FormulaItemEstruturaModalComponent, {
      width: largura > 830 ? '800px' : (($('body').width()).toString() + 'px'),
      data: {
        item: Object.assign({}, item)
      },
      panelClass: 'modal-card',
      // maxHeight: '90vh'
    });

    dialogRef.afterClosed().subscribe((result: FornecedorEstruturaItem[]) => {
      if (result) {
        this.buscarItensEstrutura();
      }
    });
  }

  filtra() {
    this.buscarItensEstrutura();
    this.paginator.firstPage();
  }

  abrirModalSimularEstrutura() {
    const largura = Number(($('body').width()));

    const dialogRef = this.dialog.open(SimulacaoEstruturaModalComponent, {
      width: largura > 830 ? '800px' : (($('body').width()).toString() + 'px'),
      data: {
        idFornecedor: this.fornecedorSelecionado,
        telhado: this.telhadoSelecionado,
        orientacao: this.orientacaoSelecionada
      },
      panelClass: 'modal-card',
    });

    // dialogRef.afterClosed().subscribe((result: any) => {});
  }

  abrirModalClonar() {
    const largura = Number(($('body').width()));

    const dialogRef = this.dialog.open(ClonarEstruturaModalComponent, {
      width: largura > 830 ? '800px' : (($('body').width()).toString() + 'px'),
      data: {
        origemIdFornecedor: this.fornecedorSelecionado,
        origemTelhado: this.telhadoSelecionado,
        origemOrientacao: this.orientacaoSelecionada
      },
      panelClass: 'modal-card',
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        // this.fornecedorSelecionado = result.destinoIdFornecedor;
        // this.telhadoSelecionado = result.destinoTelhado;
        // this.orientacaoSelecionada = result.destinoOrientacao === Orientacao.Retrato ? 'retrato': 'paisagem';

        // this.selecionarFornecedor(this.fornecedorSelecionado);
        // this.selecionarTelhado(this.telhadoSelecionado);
        // this.selecionarOrientacao(this.orientacaoSelecionada);
      }
    });
  }
}
